import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

export interface LPGroupProperties {
	classes?: string[];
	name: string;
	element?: string;
	topicroot?: string;
	kids: LPKidType[];
}

export interface LPKidType {
	widget: string;
	name?: string;
	element?: string;
	kids?: LPKidType[] | string[];
}

const factory = create({ theme }).properties<LPGroupProperties>();

export const LPGroup = factory(({ properties, middleware: { theme } }) => {
	const render_kids = (kids: LPKidType[]): DNode[] => {
		return kids.map((kid) => {
			const { widget } = kid;
			const params: Partial<LPKidType> = { ...kid };
			delete params['widget'];
			return w(widget, { ...params });
		});
	};

	const render_topicroot = (topicname: string): DNode[] => {
		topicname;
		return [];
	};

	const { classes = [], name, element = 'div', kids, topicroot } = properties();

	return v(
		element,
		{ classes: [theme.variant(), ...classes], xqa: `lpgroup ${name}` },
		topicroot ? render_topicroot(topicroot) : render_kids(kids)
	);
});

export default LPGroup;
